export enum RoomsOfferedOptions {
    UNKNOWN = 0,
    ROOM_1 = 1,
    ROOM_2 = 2,
    ROOM_3 = 3,
    ROOM_4_AND_MORE = 4,
}
